import { HStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { ColorCodedText } from '../../../../../components/ColorCodedText';
import { RecommendedPortfolioBadge } from '../../../../../components/RecommendedPortfolioBadge';
import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../components/TableContent';
import { EquityAssetsQueryItem } from '../../../../../store/customerAssetDetail/types';
import { IDynamicProductSearchItem } from '../_dynamic';

import { tableHead } from './constants';

const ProductSearchItem = ({ item, product }: IDynamicProductSearchItem<EquityAssetsQueryItem>) => {
  const getFlex = (index: number) => {
    const currentHead = tableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  return (
    <TableContent direction="row" space={0} py={Spacing['stack.xxs']} px={Spacing['inline.xxxs']}>
      <Box
        position={'absolute'}
        top={0}
        left={0}
        bottom={0}
        w={'4px'}
        backgroundColor={Color[product.colorNormalized]}
        borderTopLeftRadius={'full'}
        borderBottomLeftRadius={'full'}
      />
      <TableContentItemColumn flex={getFlex(0)}>
        <HStack space="inline.xxs" alignItems="center">
          <TableContentItemText>{item.productNameNormalized}</TableContentItemText>
          <RecommendedPortfolioBadge
            hasRecommendedPortfolioLink={item.hasRecommendedPortfolioLink}
            recommendedPortfolioLinks={item.recommendedPortfolioLinks}
            hideText
          />
        </HStack>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <TableContentItemText>{item.productCategoryNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TableContentItemText>{item.productTypeNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <TableContentItemText>{item.availableQuantityNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <TableContentItemText>{item.blockedQuantityNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(5)}>
        <TableContentItemText>{item.totalQuantityNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(6)}>
        <TableContentItemText>{item.averagePriceNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(7)}>
        <TableContentItemText>{item.actualPriceNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(8)}>
        <TableContentItemText>{item.resultNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(9)}>
        <ColorCodedText text={item.variationNormalized} sign={item.variationType} />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(10)}>
        <TableContentItemText>{item.valueNormalized}</TableContentItemText>
      </TableContentItemColumn>
    </TableContent>
  );
};

export default React.memo(ProductSearchItem);
